export enum Acronym {
    EXPERES,
    scolMAR,
    INSITES,
    AMEL,
    CORETEV,
    ICFAL
}